import { createAsyncThunk } from '@reduxjs/toolkit';
import smsApi, {
  IGetConversationsParams,
  IGetConversationsResponse,
  IGetMessagesResponse,
  ISendSmsPayload,
  IUpdateConversationPayload,
  IContactDetails,
} from '~/apis/sms';
import {
  GET_SMS_CONVERSATIONS,
  GET_SMS_MESSAGES,
  SEND_SMS,
  UPDATE_SMS_CONVERSATION,
  GET_SMS_CONTACT_DETAILS,
} from '~/utils/constants/actionType';

export const handleGetSmsConversations = createAsyncThunk<
  IGetConversationsResponse,
  { params: IGetConversationsParams }
>(
  GET_SMS_CONVERSATIONS,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await smsApi.getConversations(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetSmsMessages = createAsyncThunk<
  IGetMessagesResponse,
  { conversationId: string; params?: { page?: number; limit?: number } }
>(
  GET_SMS_MESSAGES,
  async ({ conversationId, params }, { rejectWithValue }) => {
    try {
      const res = await smsApi.getMessages(conversationId, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleSendSms = createAsyncThunk<any, ISendSmsPayload>(
  SEND_SMS,
  async (data, { rejectWithValue }) => {
    try {
      const res = await smsApi.sendSms(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateSmsConversation = createAsyncThunk<
  any,
  { conversationId: string; data: IUpdateConversationPayload }
>(
  UPDATE_SMS_CONVERSATION,
  async ({ conversationId, data }, { rejectWithValue }) => {
    try {
      const res = await smsApi.updateConversation(conversationId, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetSmsContactDetails = createAsyncThunk<
  IContactDetails,
  { conversationId: string }
>(
  GET_SMS_CONTACT_DETAILS,
  async ({ conversationId }, { rejectWithValue }) => {
    try {
      const res = await smsApi.getContactDetails(conversationId);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
